module.exports = __webpack_public_path__ + "img/japanship_mt.9e98f45f.jpg";